// src/components/MostPopular/MostPopular.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-toastify/dist/ReactToastify.css";
import ProductCard from "../ProductCard/ProductCard";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";

const getCart = () => JSON.parse(localStorage.getItem("rentalCart")) || [];

const isProductInCart = (productId, cartItems) =>
  cartItems.some((item) => item.id === productId);

const MostPopular = () => {
  const [mostPopular, setMostPopular] = useState([]);
  const [selectedQuantities] = useState({});
  const [cartItems, setCartItems] = useState(getCart());

  const fetchMostPopular = async () => {
    try {
      const response = await fetch("https://spiderlegsproductions.com/api/get_vuokrattavat.php");
      if (!response.ok) {
        throw new Error(`Laitteiden haku epäonnistui: ${response.status}`);
      }

      const data = await response.json();
      if (data.success && Array.isArray(data.items)) {
        const sortedItems = data.items
          .filter((device) => device.name && device.price)
          .sort((a, b) => Number(b.rentals || 0) - Number(a.rentals || 0));

        setMostPopular(sortedItems);
      } else {
        throw new Error("API:n vastausrakenne ei ole odotettu tai tuotteita ei löytynyt.");
      }
    } catch (error) {
      console.error("❌ Virhe tietojen haussa:", error);
    }
  };

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });
    fetchMostPopular();
    const handleCartUpdate = () => setCartItems(getCart());
    window.addEventListener("cartUpdated", handleCartUpdate);
    return () => window.removeEventListener("cartUpdated", handleCartUpdate);
  }, []);

  // const isAnyCameraInCart = cartItems.some((cartItem) => cartItem.onko_polaroid);
  // const isAnyCameraBooked = mostPopular.some((item) => item.onko_polaroid && item.isBooked);
  // const isCameraGlobalDisable = isAnyCameraInCart || isAnyCameraBooked;

  return (
    <div
      className="mx-4 dark:bg-violet bg-primary dark:bg-opacity-75 bg-opacity-75 rounded-3xl pb-10 mb-10 p-5 2xl:mx-72" 
      data-aos="fade-right"
    >
      <div className="container mx-auto">
        <div className="flex flex-row items-center flex-wrap">
          <h2
            className="text-5xl sm:text-6xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-tight text-left font-customFont2 text-darkest dark:text-primary dark:text-shadow-xxl"
            aria-label="Vuokratuimmat laitteet"
          >
            VUOKRATUIMMAT
          </h2>
          <p className="mb-10 font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light">
            Tästä osiosta löydät Spiderlegsin omat vuokrattavat laitteet sekä valikoituja tuotteita luotettavilta yhteistyökumppaneiltamme. 
            Tarjolla on suosituimmat äänentoisto- ja valopakettimme, esitystekniikkaa sekä erikoistuotteita tapahtumien tarpeisiin. 
            Valitse valmis paketti tai yhdistä laitteet vapaasti – meiltä löydät kaiken, mitä onnistunut tapahtuma vaatii.
            <br /><br />
            Jokaisen tuotteen kohdalla näet myös, missä laite sijaitsee – tieto löytyy kortin lopusta. Näin voit helposti suunnitella noudon tai mahdollisen kuljetuksen.
          </p>



        </div>

        <div className="flex justify-center">
          <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 mdd:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-6 w-full max-w-6xl px-4">
            {mostPopular.slice(0, 6).map((item) => {
              let disableAddButton = false;
              if (item.onko_polaroid && isProductInCart(item.id, cartItems)) {
                disableAddButton = false;
              }
              

              return (
                <ProductCard
                    key={item.id}
                    item={item}
                    cartItems={cartItems}
                    selectedQuantities={selectedQuantities}
                    isDisabled={disableAddButton}
                    allItems={mostPopular}
                    hideCartButtons={true}
                    hideQuantitySelector={true}
                    hideAvailableCount={true} // ← lisää tämä!
                  />

              );
            })}
          </div>
        </div>

        <div className="grid place-content-center mt-10">
        <Link
          to="/vuokrattavat"
          onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "instant" })}
          aria-label="Katso kaikki vuokrattavat laitteet"
        >
       <ResponsiveButton variant="seemore">
        Katso kaikki
      </ResponsiveButton>

        </Link>

        </div>
      </div>
    </div>
  );
};

export default MostPopular;
